"use client";

import { type MotionValue, motion, useTransform } from "motion/react";
import { createContext, type ReactNode, useContext } from "react";
import type { TooltipData } from "./chart-context";
import { useChartProjection, useProjectionProgress } from "./projection";

export interface BarProjectionValue {
  slots: ReadonlyMap<string, SVGGElement>;
  lanes: number;
  laneDepth: number;
  interactive: boolean;
  reveal: MotionValue<number>;
  enter: (tooltip: TooltipData) => void;
  leave: () => void;
  tap: (tooltip: TooltipData) => void;
}

export const barSlotKey = (category: number, lane: number): string =>
  `${category}:${lane}`;

const BarProjectionContext = createContext<BarProjectionValue | null>(null);

export const BarProjectionProvider = BarProjectionContext.Provider;

export function useBarProjection(): BarProjectionValue | null {
  return useContext(BarProjectionContext);
}

export function ProjectionFadeOut({ children }: { children: ReactNode }) {
  const projection = useChartProjection();
  const e = useProjectionProgress(projection);
  const opacity = useTransform(e, [0, 0.4], [1, 0]);
  return (
    <motion.g pointerEvents={projection?.isometric ? "none" : undefined} style={{ opacity }}>
      {children}
    </motion.g>
  );
}
